import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Clock, Ticket, BookOpen, Activity, ArrowLeft } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { api } from "@/lib/api";

const Row = ({ icon: Icon, label, value, testid }) => (
  <div className="flex items-center gap-3 rounded-lg border border-line bg-bg-elevated/50 px-4 py-3" data-testid={testid}>
    <Icon className="h-4 w-4 text-brand-amber shrink-0" />
    <div>
      <div className="font-mono text-[9px] uppercase tracking-wider text-ink-muted">{label}</div>
      <div className="text-sm text-ink-primary">{value}</div>
    </div>
  </div>
);

export default function ContactSupport() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/helpdesk/settings").then((r) => setSettings(r.data)).catch(() => setSettings({})); }, []);

  return (
    <div className="max-w-2xl space-y-6" data-testid="contact-support-page">
      <Link to="/dashboard/help" className="inline-flex items-center gap-1.5 text-xs text-ink-muted hover:text-ink-primary">
        <ArrowLeft className="h-3.5 w-3.5" /> Help Center
      </Link>
      <PageHeader eyebrow="// SUPPORT" title="Contact support"
        description="The fastest way to reach us is a support ticket — it keeps the whole conversation and history in one place." />

      <div className="rounded-xl border border-brand-amber/30 bg-brand-amber/5 p-5">
        <div className="text-sm font-semibold text-ink-primary mb-1">Open a support ticket</div>
        <p className="text-xs text-ink-secondary mb-4">Tracked, prioritized, and answered by the team — with your station context attached automatically.</p>
        <Link to="/dashboard/support/new" data-testid="contact-open-ticket-btn"
          className="inline-flex items-center gap-1.5 rounded-md bg-brand-amber px-4 py-2.5 text-sm font-semibold text-black hover:bg-brand-amber/90 transition">
          <Ticket className="h-4 w-4" /> Submit a ticket
        </Link>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        <Row icon={Mail} label="Support email" testid="contact-email"
          value={settings === null ? "…" : settings.support_email || "Not configured yet — use a support ticket"} />
        <Row icon={Clock} label="Support hours" testid="contact-hours"
          value={settings === null ? "…" : settings.support_hours || "Not configured yet"} />
      </div>

      <div className="grid sm:grid-cols-3 gap-3">
        <Link to="/dashboard/support/tickets" className="rounded-lg border border-line bg-bg-surface px-4 py-3 text-center hover:border-brand-amber/40 transition" data-testid="contact-link-tickets">
          <Ticket className="h-4 w-4 text-brand-amber mx-auto mb-1" />
          <span className="text-xs text-ink-primary">My Support Tickets</span>
        </Link>
        <Link to="/dashboard/help" className="rounded-lg border border-line bg-bg-surface px-4 py-3 text-center hover:border-brand-amber/40 transition" data-testid="contact-link-help">
          <BookOpen className="h-4 w-4 text-brand-amber mx-auto mb-1" />
          <span className="text-xs text-ink-primary">Help Center</span>
        </Link>
        <div className="rounded-lg border border-line bg-bg-surface px-4 py-3 text-center opacity-60" data-testid="contact-link-status">
          <Activity className="h-4 w-4 text-ink-muted mx-auto mb-1" />
          <span className="text-xs text-ink-muted">System Status — coming soon</span>
        </div>
      </div>
    </div>
  );
}
